import { VStack } from "@gluestack-ui/themed";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { Text } from "@repo/core/components/core/Text";
import { SelectControlled } from "@repo/core/components/forms/SelectControlled";
import { ProgressBar } from "@repo/core/components/layout/ProgressBar";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";

import { AddressDataFormController } from "./controller";
import { ResidenceTypeOptions } from "@repo/core/constants/proposals";

const AddressDataForm = () => {
  const {
    control,
    handleOnSubmitForm,
    handleClose,
    handleGoBack,
    onChangeZipCode,
    statesOptions,
    citiesOptions,
    residentialPhoneTypeOptions,
    isResidentialPhone2TypeRequired,
    isSubmitting,
    handleAdditionalPhoneBlur,
    handleAdditionalPhoneChange
  } = AddressDataFormController();

  return (
    <PageScaffold
      onBackPress={handleGoBack}
      showBackButtonOnWeb
      onPressRightIcon={handleClose}
      rightWebLabel="Fechar"
      title="Proposta de Crédito"
      footerContent={
        <ScaffoldFooter
          primaryText="Continuar"
          primaryAction="primary"
          primaryOnPress={handleOnSubmitForm}
          primaryIsLoading={isSubmitting}
          primaryIsDisabled={isSubmitting}
        />
      }
    >
      <VStack w="$full" gap="$4" pb="$4">
        <ProgressBar progress={40} />
        <Text>Endereço residencial:</Text>

        <SelectControlled
          control={control}
          isRequired
          label="Tipo de Residência"
          name="residenceType"
          placeholder="Selecione o tipo de residência"
          options={ResidenceTypeOptions ?? []}
        />

        <InputControlled
          control={control}
          isRequired
          label="CEP"
          name="zipCode"
          placeholder="Digite o CEP"
          mask="cep"
          keyboardType="number-pad"
          maxLength={9}
          onChange={onChangeZipCode}
        />

        <InputControlled
          control={control}
          isRequired
          label="Endereço"
          name="addressLine1"
          placeholder="Digite o endereço"
        />

        <InputControlled
          control={control}
          isRequired
          label="Número"
          name="number"
          placeholder="Digite o número"
          keyboardType="number-pad"
          mask="number"
          maxLength={7}
        />
        <InputControlled
          control={control}
          label="Complemento"
          name="addressLine2"
          placeholder="Digite o complemento"
        />

        <InputControlled
          control={control}
          isRequired
          label="Bairro"
          name="neighborhood"
          placeholder="Digite o bairro"
        />

        <SelectControlled
          control={control}
          isRequired
          label="Estado"
          name="state"
          placeholder="Selecione o estado"
          options={statesOptions ?? []}
        />

        <SelectControlled
          control={control}
          isRequired
          label="Cidade"
          name="city"
          placeholder="Selecione a cidade"
          options={citiesOptions ?? []}
        />

        <Text>Telefone adicional (opcional):</Text>

        <InputControlled
          control={control}
          label="DDD + Telefone adicional"
          name="residentialPhone2"
          placeholder="(00) 00000-0000"
          mask="cellphone"
          keyboardType="number-pad"
          onBlur={handleAdditionalPhoneBlur}
          onChange={handleAdditionalPhoneChange}
        />

        <SelectControlled
          control={control}
          isRequired={isResidentialPhone2TypeRequired}
          label="Tipo do telefone adicional"
          name="residentialPhone2Type"
          placeholder="Selecione o tipo"
          options={residentialPhoneTypeOptions}
        />
      </VStack>
    </PageScaffold>
  );
};

export default AddressDataForm;
